import { KeyValueModel } from "model";
import { EnumStatusMovimentacaoEstoque } from "model/enums/enum-status-movimentacoes-estoque";

export const  statusMovimentacaoEstoqueMock: KeyValueModel[] = [
    new KeyValueModel(EnumStatusMovimentacaoEstoque.APROVAR, 'Aprovar'),
    new KeyValueModel(EnumStatusMovimentacaoEstoque.DESRESERVAR, 'Desreservar'),
    new KeyValueModel(EnumStatusMovimentacaoEstoque.ESTORNAR, 'Estornar'),
    new KeyValueModel(EnumStatusMovimentacaoEstoque.RESERVAR, 'Reservar')

]